import { createContext, useContext } from "react";
import { EditorContent } from "@tiptap/react";
import Toolbar from "./Toolbar";
import styles from "./styles.module.scss";

const WysiwygEditorContext = createContext();

export const useWysiwygEditor = () => useContext(WysiwygEditorContext);

export function ToolbarCompound() {
  const { editor } = useWysiwygEditor();
  return <Toolbar editor={editor} />;
}

export function EditorCompound() {
  const { editor } = useWysiwygEditor();
  return (
    <EditorContent
      editor={editor}
      className={styles["sender-editor"]}
      aria-label="sender-editor"
    />
  );
}

export default WysiwygEditorContext;
